import React from 'react';
import ScreeningCard from '../../../components/Lead/Screening/ScreeningCard';

export default class ScreeningTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div style={{maxWidth: "90%"}}>
                <ScreeningCard requestId={this.props.requestId}/>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// app/views/Lead/Screening/ScreeningTemplate.jsx